<template>
	<div class="file-container">

		<div :key="index" v-for="(file, index) in files" :xs="24" :sm="12" :md="12" :lg="8" :xl="6" class="file-item">

			<!-- Image -->
			<el-image v-if="isImage(file)" :src="file.src" :preview-src-list="imageSrcs" fit="contain" class="file">
				<div slot="error" class="image-slot el-image__error"><i class="far fa-image fa-3x"></i></div>
			</el-image>

			<!-- PDF -->
			<div v-else-if="isPDF(file)" class="file clickable" v-on:click="downloadFile(file)">
				<div>
					<i class="far fa-file-alt fa-3x"></i><br>Fichier PDF
				</div>
			</div>

			<!-- Video -->
			<div v-else-if="isVideo(file)" class="file">
				<video v-if="file.url" controls preload="metadata" class="video">
					<source :src="file.url" >
				</video>
			</div>

		</div>

	</div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import TokenService from '@/services/token.service'
import CheckupService from '@/services/checkup.service'

export default {
	name: "CheckupPart5",
	props: {
		files: { type: Array }
    },
	computed: {
		imageSrcs() {
			return !this.files ? [] : this.files.filter(f => this.isImage(f) && f.src).map(f => f.src);
		}
	},
	methods: {
		loadFiles: function () {

			if (this.files && this.files.length) {
				
				for (const file of this.files) {

					// Si c'est une photo et qu'elle n'a pas déjà été chargée
					if (this.isImage(file) && !file.src) {
						axios.get('/file/checkup-file/' + file.victimId + '/' + file.order + '/' + file.numfile, { responseType: 'arraybuffer' } ).then(response => {
							if (response.data && response.data.byteLength > 0) {
								Vue.set(file, 'src', 'data:;base64,' + btoa(new Uint8Array(response.data).reduce((data, byte) => data + String.fromCharCode(byte),'')))
							}
						});
					}

					// Si c'est une vidéo
					else if (this.isVideo(file)) {
						Vue.set(file, 'url', axios.defaults.baseURL + 'file/checkup-file/video/' + file.victimId + '/' + file.order + '/' + file.numfile + '?token=' + TokenService.getToken())
					}
				}
			}
		},

		isImage: function (file) {
			return file && file.mimeType && file.mimeType.startsWith('image')
		},

		isPDF: function (file) {
			return file && file.mimeType && file.mimeType === 'application/pdf'
		},

		isVideo: function (file) {
			return file && file.mimeType && file.mimeType.startsWith('video')
		},

		downloadFile: function (file) {
			CheckupService.downloadFile(file.victimId, file.order, file.numfile, file.mimeType)
		}
	}
};
</script>

<style scoped>

.file-container {
	display: flex;
	flex-wrap: wrap;
	justify-content: space-evenly;
	gap: 20px;
}

.file-item {
	text-align: center;
	border: 1px solid #efefef;
	height: 250px;
	width: calc(25% - 18px);
}

.file-item:hover {
	border-color: #ccc;
}

.file {
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	line-height: 250%;
}

.video {
	width: 100%;
	height: 100%;
}

.clickable {
	cursor: pointer;
}

@media only screen and (max-width:991px) {

	.file-item {
		height: 200px;
		width: calc(33% - 14px);
	}
}

@media only screen and (max-width:767px) {

	.file-item {
		height: 150px;
		width: calc(50% - 12px);
	}
}

</style>